const unifiedSetTimeout = (fn, ms) => setTimeout(fn, ms);
const unifiedClearTimeout = (id) => clearTimeout(id);
const raf = typeof requestAnimationFrame === "undefined" ? (fn) => unifiedSetTimeout(fn, 1e3 / 60) : (fn) => requestAnimationFrame(fn);
const cancelRaf = typeof cancelAnimationFrame === "undefined" ? unifiedClearTimeout : (id) => cancelAnimationFrame(id);
function debounce(fn, ms = "animationFrame", leading = false) {
  const defer = ms === "animationFrame" ? (fn2) => raf(fn2) : (fn2) => setTimeout(fn2, ms);
  const cancelDeferred = ms === "animationFrame" ? cancelRaf : unifiedClearTimeout;
  let pending = null;
  const scheduleNext = (scheduledFn, ...args) => {
    const wrappedCall = () => {
      scheduledFn(...args);
      pending = null;
    };
    pending = { wrappedCall, id: defer(wrappedCall) };
  };
  const cancelScheduled = () => {
    if (pending) {
      cancelDeferred(pending.id);
      pending = null;
    }
  };
  const debounced = !leading ? function(...args) {
    cancelScheduled();
    scheduleNext(fn, ...args);
  } : function(...args) {
    if (pending === null) {
      fn(...args);
    } else {
      cancelScheduled();
    }
    scheduleNext(() => {
      pending = null;
    });
  };
  debounced.cancel = () => {
    cancelScheduled();
  };
  debounced.flush = () => {
    if (pending !== null) {
      const pendingCall = pending.wrappedCall;
      cancelScheduled();
      if (!leading) {
        pendingCall();
      }
    }
  };
  return debounced;
}
export { debounce };
